module.exports = __webpack_public_path__ + "img/team.d5c98eca.svg";